import React from 'react';
import { Container } from '@material-ui/core';
import ReportList from './ReportList';
import useStyles from './styles';

interface IProps {}

const Reports = (props: IProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <ReportList />
    </Container>
  );
};

export default Reports;
